import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TabsPage } from '../tabs/tabs';

/**
 * Generated class for the RegistrationCompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-registration-complete',
  templateUrl: 'registration-complete.html',
})
export class RegistrationCompletePage {
public data: any = {
  title:'',
  message:''
};

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    
    this.data.title = this.navParams.get('title');
    this.data.message = this.navParams.get('message');
  }

  goToDashboard(){
    this.navCtrl.setRoot(TabsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/registration-complete/registration-complete.ts